import Layout from "./components/Layout";
import { Linkedin, Github, FileText } from "lucide-react";

function Home() {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center text-center min-h-[80vh] py-12">
        <h1 className="text-6xl md:text-7xl font-semibold tracking-tight font-inter mb-2">
          murthyz.com
        </h1>
        <p className="text-xs md:text-sm font-semibold tracking-[0.4em] uppercase opacity-70 font-inter mb-10">
          Personal Portfolio
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://linkedin.com/in/sidmurthy"
            target="_blank"
            rel="noreferrer"
            className="group flex items-center rounded-full px-5 py-3 backdrop-blur-2xl border border-white/30 bg-white/10 hover:bg-white/20 active:scale-95 transition-all shadow-lg"
            title="LinkedIn"
          >
            <Linkedin
              size={22}
              className="transition-transform duration-300 group-hover:scale-110"
            />
            <span className="reveal-wrapper">
              <span className="reveal-text text-sm font-medium">
                Connect on LinkedIn
              </span>
            </span>
          </a>
          <a
            href="https://github.com/SidM4"
            target="_blank"
            rel="noreferrer"
            className="group flex items-center rounded-full px-5 py-3 backdrop-blur-2xl border border-white/30 bg-white/10 hover:bg-white/20 active:scale-95 transition-all shadow-lg"
            title="GitHub"
          >
            <Github
              size={22}
              className="transition-transform duration-300 group-hover:scale-110"
            />
            <span className="reveal-wrapper">
              <span className="reveal-text text-sm font-medium">
                Explore GitHub
              </span>
            </span>
          </a>
          <a
            href="/resume"
            className="group flex items-center rounded-full px-5 py-3 backdrop-blur-2xl border border-white/30 bg-white/10 hover:bg-white/20 active:scale-95 transition-all shadow-lg"
            title="Resume"
          >
            <FileText
              size={22}
              className="transition-transform duration-300 group-hover:scale-110"
            />
            <span className="reveal-wrapper">
              <span className="reveal-text text-sm font-medium">
                View Resume
              </span>
            </span>
          </a>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
